import React from 'react';
import ReactTooltip from 'react-tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

interface ILabel {
  id: string;
  for?: string;
  tooltip?: string;
  mandatory?: boolean;
}

const Label: React.FC<ILabel> = (props) => {
  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex justify-content-start">
        <div className="label">{props.children}</div>
        {props.mandatory && <div className="color-mandatory">*</div>}
      </div>
      <div>
        {props.tooltip && (
          <div
            className="label-tooltip"
            data-tip={props.tooltip}
            data-multiline={true}
            data-for={props.id}
            data-place="right"
            data-type="light"
            data-effect="solid"
            data-class="form-tooltip"
          >
            <FontAwesomeIcon icon={faCircleQuestion as IconProp} className="text-xl color-blue" />
            <ReactTooltip id={props.id} backgroundColor="#c7c7c7" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Label;
